function e(e){return typeof e==`object`&&!!e}export{e as isObjectType};
//# sourceMappingURL=isObjectType-BCPQvhHe.js.map